<template>
    <div class="transactionList">
        <TransactionEntry v-for="(t, index) in transactionList" :key="index" :entry="t" :prev="transactionList[index-1]" class="tEntry"></TransactionEntry>
    </div>
</template>

<script>
import TransactionEntry from './TransactionEntry.vue'
export default {
    props: {
        transactionList: {
            type: Array,
            required: true
        }
    },
	components: { TransactionEntry }
}
</script>

<style lang="scss" scoped>
.transactionList {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    background-color: #FFF;
    height: 90vh;
    overflow-y: auto;
}

</style>